import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type { LatLng } from '~/_shared/types/latLng';
import { useProximityLocation } from '~/map/map/proximity/useProximityLocation';
import { useProximities } from '~/proximity/useProximities';
import {
  setActiveOverlappingElementsProximity, setActiveOverlappingLocation,
} from '~/store/frontendState/activeMapElements/activeMapElements.actionCreators';
import { EMPTY_OVERLAP } from '~/store/frontendState/activeMapElements/activeMapElements.sagas';

export const useOverlappingProximitiesAtLocation = () => {
  const { proximities } = useProximities();
  const { getProximitiesAtLocation } = useProximityLocation();
  const dispatch = useDispatch();

  return useCallback((loc: LatLng | null) => {
    if (loc) {
      dispatch(setActiveOverlappingLocation(loc));
      const elements = getProximitiesAtLocation(loc, proximities);
      dispatch(setActiveOverlappingElementsProximity(elements));
    }
    else {
      dispatch(setActiveOverlappingLocation(null));
      dispatch(setActiveOverlappingElementsProximity(EMPTY_OVERLAP));
    }
  }, [dispatch, getProximitiesAtLocation, proximities]);
};
